import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Map.css';
import 'ol/ol.css';
import Select from "ol/interaction/Select";
import { pointerMove, click } from "ol/events/condition";
import { Map as OLMap, View } from 'ol';
import OSM from "ol/source/OSM";
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import { fromLonLat, transformExtent } from 'ol/proj';
import Draw from "ol/interaction/Draw";
import { getArea as getGeodesicArea } from "ol/sphere";
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Feature } from 'ol';
import { Polygon } from 'ol/geom';
import { Style, Stroke, Fill } from 'ol/style';
import Overlay from "ol/Overlay";
import { LineString } from "ol/geom";
import { getLength } from "ol/sphere";
import { unByKey } from "ol/Observable";

import { detectresult } from '../../api/aidetect/detectApi';
import { useProject } from '../../ProjectContext';
import { useAuth } from '../../context/AuthContext'; // ✅ AuthContext 불러오기

// chart


import Subtractionicon from "../../Images/utilImages/Subtracticon.png"





// 도로 시설물 표시 아이콘
import Traffic_light from '../../Images/pinImages/Traffic_light.png'   //신호등 아이콘
import Traffic_sign from '../../Images/pinImages/Traffic_sign.png'     //교통 표지판 아이콘
import Manhole from '../../Images/pinImages/Manhole.png'               // 맨홀 아이콘
import Drain from '../../Images/pinImages/Drain.png'                   // 배수구 아이콘
import Streetlight from '../../Images/pinImages/Streetlight.png'       //가로등 아이콘
// 차선 및 도로 표시 아이콘
import lane_line from '../../Images/pinImages/solid_line.png';        // 0 실선
import dotted_line from '../../Images/pinImages/dotted_line.png';      // 1 점선
import stop_line from '../../Images/pinImages/stop_line.png';          // 2 정지선
import arrow from '../../Images/pinImages/arrow.png';                  // 3 화살표
import crosswalk from '../../Images/pinImages/crosswalk.png';          // 4 횡단보도
import diamond from '../../Images/pinImages/diamond.png';              // 5 다이아몬드
import zigzag from '../../Images/pinImages/zigzag.png';                // 6 지그재그
import center_line from '../../Images/pinImages/center_line.png';      // 7 중앙선
import triangle from '../../Images/pinImages/triangle.png';            // 8 삼각형
import safety_zone from '../../Images/pinImages/safety_zone.png';      // 9 안전지대
import lettering from '../../Images/pinImages/lettering.png';          // 10 문자표시
import edge_line from '../../Images/pinImages/edge_line.png';          // 11 가장자리선
import bus_stop from '../../Images/pinImages/bus_stop.png';            // 12 버스정류장
import speed_bump from '../../Images/pinImages/speed_bump.png';        // 13 과속방지턱

//FOD 표시 아이콘
import tire from '../../Images/pinImages/tire.png';                    // 타이어
import rock from '../../Images/pinImages/rock.png';                    // 돌
import traffic_cone from '../../Images/pinImages/traffic_cone.png';    // 꼬깔콘
import styrofoam_box from '../../Images/pinImages/styrofoam_box.png';  // 스티로폼
import cardboard_box from '../../Images/pinImages/cardboard_box.png';  // 박스

// 포트홀 표시 아이콘
import patch from '../../Images/pinImages/patch.png';                   // 포트홀(보수완료)
import pothole from '../../Images/pinImages/pothole.png';               // 포트홀

// 크렉 표시 아이콘
import linear_crack from '../../Images/pinImages/linear_crack.png';     // 크렉
import DetectionDashboard from '../Popup/DetectionDashboard/DetectionDashboard';
import DamageLegend from '../Popup/DamageLegend/DamageLegend';

const API_KEY = "Zawpqp2wd0kq9cmxzm"; // ✅ 발급받은 API 키를 여기에 입력

// 이미지 매핑 객체
const imageMap = {
  // 시설물 탐지 클래스
  Traffic_light,
  Traffic_sign,
  Manhole,
  Drain,
  Streetlight,
 // 차선 탐지 클래스
  lane_line,
  //solid_line,
  dotted_line,
  stop_line,
  arrow,
  crosswalk,
  diamond,
  zigzag,
  center_line,
  triangle,
  safety_zone,
  lettering,
  edge_line,
  bus_stop,
  speed_bump,
  // FOD
  tire,
  rock,
  traffic_cone,
  styrofoam_box,
  cardboard_box,
  // 포트홀 
  patch,
  pothole,
 // crack
 linear_crack
};

// ✅ 영어 → 한국어 이름 매핑
const nameMap = {
  Traffic_light: "신호등",
  Traffic_sign: "교통 표지판",
  Manhole: "맨홀",
  Drain: "배수구",
  Streetlight: "가로등",
  //solid_line: "실선",
  dotted_line: "점선",
  lane_line: "차선",
  stop_line: "정지선",
  arrow: "화살표",
  crosswalk: "횡단보도",
  diamond: "횡단보도 예고",
  zigzag: "지그재그",
  center_line: "중앙선",
  triangle: "삼각 표시",
  safety_zone: "안전지대",
  lettering: "문자 표시",
  edge_line: "길 가장자리 구역선",
  bus_stop: "버스 정류장",
  speed_bump: "과속방지턱",
  tire: "타이어",
  rock: "돌",
  traffic_cone: "안전콘",
  styrofoam_box: "스티로폼 박스",
  cardboard_box: "골판지 상자",
  // 포트홀
  patch: "포트홀 (보수완료)",
  pothole: "포트홀",
  // crack
  linear_crack:"크랙"
};

const Map = () => {
  const { t } = useTranslation('map');
  const mapRef = useRef(null);
  const olMapRef = useRef(null);
  const currentLayerRef = useRef(null);
  const [mapConfig, setMapConfig] = useState(null);
  const [opacity, setOpacity] = useState(1); // ✅ 투명도 상태
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [popupPixel, setPopupPixel] = useState(null);
  const {  projectInfo } = useProject();
  const { groupId, projectId, fileId, modelType } = projectInfo;
  const [detectionData, setDetectionData] = useState(null);
  const [reloadKey, setReloadKey] = useState(0); // 🔹 강제 리로드 트리거
  const { userRole } = useAuth(); // ✅ 현재 로그인된 사용자 role 가져오기
  const { userCompany } = useAuth(); // ✅ 현재 로그인된 사용자 role 가져오기

  //그리기
  const [isMeasuring, setIsMeasuring] = useState(false); // 측정 모드 토글
  const [drawLayer, setDrawLayer] = useState(null); // 사용자가 그린 폴리곤 레이어
  const [measureResult, setMeasureResult] = useState(null); // { drawnArea, features, featuresAreaSum, ratio }
  
  // 🔹 groupId/projectId/fileId가 선택될 때마다 강제로 리로드
  useEffect(() => {
    if (groupId && projectId && fileId) {
      setReloadKey((prev) => prev + 1); // 값이 같아도 useEffect 트리거됨
    }
  }, [groupId, projectId, fileId]);


  // ✅ 공통 UI 박스 컴포넌트
  const InfoBox = ({ label, value }) => (
    <div
      style={{
        textAlign: "center",
        fontSize: "13px",
        color: "#BBBBBB",
        backgroundColor: "#1E2027",
        borderRadius: "6px",
        padding: "6px 8px",
        marginTop: "4px",
        wordBreak: "keep-all",
      }}
    >
      {label}:{" "}
      <span style={{ color: "#59D89E", fontWeight: "600" }}>{value}</span>
    </div>
  );

  // Draw (면적 측정) 상호작용: 한 번에 한 개의 폴리곤만 유지
  useEffect(() => {
    if (!olMapRef.current) return;

    const map = olMapRef.current;

    // 기존 Layer 제거
    if (drawLayer) {
      map.removeLayer(drawLayer);
      setDrawLayer(null);
    }

    const source = new VectorSource();
    const layer = new VectorLayer({
      source,
      zIndex: 10000,
      style: new Style({
        stroke: new Stroke({ color: "#9D91FF", width: 3 }),
        fill: new Fill({ color: "rgba(255,255,255,0.2)" }),
      }),
    });
    map.addLayer(layer);
    setDrawLayer(layer);

    const draw = new Draw({
      type: "Polygon",
      source,
    });

    // ==========================
    // ✨ 선분 거리 실시간 Tooltip
    // ==========================
    const liveTooltip = document.createElement("div");
    liveTooltip.style.cssText =
      "position:relative;background:rgba(43,46,58,0.85);padding:6px 10px;border-radius:6px;color:#fff;font-size:13px;font-weight:600;border:1px solid rgba(255,255,255,0.25)";
    const liveOverlay = new Overlay({ element: liveTooltip, offset: [10, 0], positioning: "center-left" });
    map.addOverlay(liveOverlay);

    let geometryListener = null;
    let segmentLabels = []; // 각 선분 라벨 overlay 저장
    let resultOverlay = null; // 총 둘레 결과 overlay 저장
    

    draw.on("drawstart", (evt) => {
      const geom = evt.feature.getGeometry();

      // 기존 segment 라벨 제거
      segmentLabels.forEach((o) => map.removeOverlay(o));
      segmentLabels = [];

      geometryListener = geom.on("change", (e) => {
        const coords = geom.getCoordinates()[0];
        if (coords.length < 2) return;

        const last = coords[coords.length - 1];
        const prev = coords[coords.length - 2];

        const lastLine = new LineString([prev, last]);
        const length = getLength(lastLine);
        const display = length > 1000 ? (length / 1000).toFixed(2) + " km" : length.toFixed(2) + " m";

        liveTooltip.innerHTML = `${t("line.Line")}: <strong>${display}</strong>`;
        liveOverlay.setPosition(last);
      });
    });

    // ==========================
    // 🔥 draw 완료 시: 면적 + 둘레 + 각 선분 라벨
    // ==========================
    draw.on("drawend", (evt) => {
      const feature = evt.feature;
      const geom = feature.getGeometry();
      const coords = geom.getCoordinates()[0];

      // 실시간 Tooltip 제거
      if (geometryListener) unByKey(geometryListener);
      liveTooltip.style.display = "none";

      // --------------------
      // ① 전체 둘레 길이 계산
      // --------------------
      let perimeter = 0;
      for (let i = 1; i < coords.length; i++) {
        perimeter += getLength(new LineString([coords[i - 1], coords[i]]));
      }

      const formattedPerimeter =
        perimeter > 1000 ? (perimeter / 1000).toFixed(2) + " km" : perimeter.toFixed(2) + " m";

      // ⏺ 둘레 Overlay 표시
      const perimeterDiv = document.createElement("div");
      perimeterDiv.style.cssText =
        "position:relative;background:#222;padding:6px 12px;border-radius:8px;color:#9D91FF;font-weight:700;font-size:14px;box-shadow:0 3px 8px rgba(0,0,0,0.35)";
      perimeterDiv.innerHTML = `${t("line.totalLine")}: ${formattedPerimeter}`;
      const perOverlay = new Overlay({ element: perimeterDiv, positioning: "bottom-center", offset: [0, -10] });
      map.addOverlay(perOverlay);
      perOverlay.setPosition(coords[coords.length - 2]); // 마무리 지점 근처
      resultOverlay = perOverlay; //최종 거리 둘례 결과 

      // --------------------
      // ② 각 선분 길이 라벨 표시
      // --------------------
      for (let i = 1; i < coords.length; i++) {
        const p1 = coords[i - 1];
        const p2 = coords[i];
        const len = getLength(new LineString([p1, p2]));
        const label = len > 1000 ? (len / 1000).toFixed(2) + " km" : len.toFixed(2) + " m";

        const mid = [(p1[0] + p2[0]) / 2, (p1[1] + p2[1]) / 2];

        const div = document.createElement("div");
        div.style.cssText =
          "position:relative;background:rgba(0,0,0,0.75);padding:4px 8px;border-radius:6px;color:#fff;font-size:12px;font-weight:600;white-space:nowrap;border:1px solid rgba(255,255,255,0.2)";
        div.innerHTML = label;

        const overlay = new Overlay({ element: div, positioning: "center-center" });
        overlay.setPosition(mid);
        map.addOverlay(overlay);
        segmentLabels.push(overlay);
      }

      // 면적 계산 및 기존 로직 실행
      const drawnArea = getGeodesicArea(geom);
      const layers = map.getLayers().getArray();
      const detectLayers = layers.filter((l) => l.getZIndex?.() === 9999);

      let matched = [];
      detectLayers.forEach((l) =>
        l.getSource()
          ?.getFeatures()
          ?.forEach((f) => geom.intersectsCoordinate(f.getGeometry().getInteriorPoint().getCoordinates()) && matched.push(f))
      );

      const sum = matched.reduce((a, f) => a + Number(f.get("area_m2") ?? 0), 0);
      const ratio = drawnArea > 0 ? sum / drawnArea : null;

      setMeasureResult({
        drawnArea,
        matchedCount: matched.length,
        featuresAreaSum: sum,
        ratio,
        matchedFeatures: matched,
        perimeter, // 🔥 필요 시 결과 박스에도 사용 가능
      });

      map.removeInteraction(draw);
    });

    if (isMeasuring) map.addInteraction(draw);

    return () => {
      map.removeInteraction(draw);
      if (layer) map.removeLayer(layer);
      map.removeOverlay(liveOverlay);
      segmentLabels.forEach((o) => map.removeOverlay(o));
      if (resultOverlay) map.removeOverlay(resultOverlay);
    };
  }, [olMapRef.current, isMeasuring, detectionData]);

  // ✅ 프로젝트 정보 변경 시 자동으로 탐지 API 호출
  useEffect(() => {
    const fetchDetectResult = async () => {
      if (!groupId || !projectId || !fileId || !modelType) {
        console.warn("⚠️ 프로젝트 정보가 존재하지 않습니다. 탐지 API 호출 불가");
        return;
      }

      try {
        console.log("🛰️ AI 탐지 API 호출 중...", groupId, projectId, fileId, modelType);
        const res = await detectresult(groupId, projectId, fileId, modelType);
        console.log("✅ 탐지 결과:", res.data);
        setDetectionData(res.data);
      } catch (err) {
        console.error("❌ 탐지 결과 가져오기 실패:", err);
      }
    };

    fetchDetectResult();
  }, [groupId, projectId, fileId, modelType]);

  // 2️⃣ XML(tilemapresource.xml) 조회
  useEffect(() => {
  if (!groupId || !projectId || !fileId) return;

  let isCancelled = false;

  const fetchTileMetadata = async () => {
    try {
      const url = `https://d-road.dromii.com/ai/api/ortho/${groupId}/${projectId}/${fileId}/tilemapresource.xml`;
      const response = await fetch(url, { headers: { "API-Key": API_KEY } });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const text = await response.text();
      const xml = new window.DOMParser().parseFromString(text, "text/xml");

      const bbox = xml.querySelector("BoundingBox");
      let extent = [
        parseFloat(bbox.getAttribute("minx")),
        parseFloat(bbox.getAttribute("miny")),
        parseFloat(bbox.getAttribute("maxx")),
        parseFloat(bbox.getAttribute("maxy")),
      ];

      extent = transformExtent(extent, "EPSG:4326", "EPSG:3857");

      const tileSets = xml.querySelectorAll("TileSet");
      const zoomLevels = Array.from(tileSets).map((ts) =>
        parseInt(ts.getAttribute("order"))
      );

      if (!isCancelled) {
        setMapConfig({
          extents: extent,
          minZoom: Math.min(...zoomLevels),
          maxZoom: Math.max(...zoomLevels),
        });
      }
    } catch (err) {
      console.error("❌ XML 조회 실패:", err);
      if (!isCancelled) setMapConfig(null);   // ⬅ 중요함
    }
  };

  fetchTileMetadata();

  return () => {
    isCancelled = true;
  };
  }, [ projectId, fileId, reloadKey]);

  // ✅ Orthophoto + Crack 웹타일 레이어 추가 (최적화 버전)
  useEffect(() => {
    if (!olMapRef.current || !mapConfig || !groupId || !projectId || !fileId) return;

    const map = olMapRef.current;

    // ✅ 기존 타일 레이어 제거
    if (currentLayerRef.current?.length) {
      currentLayerRef.current.forEach((layer) => map.removeLayer(layer));
      currentLayerRef.current = [];
    }

    // ✅ cacheBuster를 zoom 이벤트에서 갱신하도록 변경
    let cacheBuster = Date.now();

    const createTileLayer = (type = "base", zIndex = 1) => {
      const source = new XYZ({
        tileSize: 512,
        projection: "EPSG:3857",
        minZoom: mapConfig.minZoom,
        maxZoom: mapConfig.maxZoom,
        tileUrlFunction: ([z, x, y]) => {
          const flippedY = Math.pow(2, z) - 1 - y;
    
          // ✅ 타입별 파라미터 처리
          let extraParam = "";
          if (type === "crack") extraParam = "&crack=1";
          else if (type === "pothole") extraParam = "&pothole=1";
    
          return `https://d-road.dromii.com/ai/api/ortho/${groupId}/${projectId}/${fileId}/${z}/${x}/${flippedY}.png?cb=${cacheBuster}${extraParam}`;
        },
        tileLoadFunction: (imageTile, src) => {
          fetch(src, { headers: { "API-Key": API_KEY } })
            .then((res) => {
              if (!res.ok) throw new Error(`HTTP ${res.status}`);
              return res.blob();
            })
            .then((blob) => {
              const newUrl = URL.createObjectURL(blob);
              const img = imageTile.getImage();
    
              const oldUrl = img.src;
              img.onload = () => {
                if (oldUrl && oldUrl.startsWith("blob:")) {
                  URL.revokeObjectURL(oldUrl);
                }
              };
    
              img.src = newUrl;
            })
            .catch((err) =>
              console.error(`❌ ${type.toUpperCase()} 타일 로드 실패:`, err)
            );
        },
      });
    
      return new TileLayer({
        source,
        opacity: 1,
        zIndex,
      });
    };
    
    // ✅ Orthophoto + Crack + Pothole 레이어 생성
    const baseLayer = createTileLayer("base", 1);
    const crackLayer = createTileLayer("crack", 2);
    const potholeLayer = createTileLayer("pothole", 3);
    
    // ✅ 지도에 추가
    map.addLayer(baseLayer);
    map.addLayer(crackLayer);
    map.addLayer(potholeLayer);
    
    currentLayerRef.current = [baseLayer, crackLayer, potholeLayer];
    
    // ✅ 지도 영역 맞추기
    map.getView().fit(mapConfig.extents, { padding: [50, 50, 50, 50] });
    
    // ✅ 확대/축소 시 자동 새로고침 (cacheBuster 갱신)
    const view = map.getView();
    const handleZoomChange = () => {
      cacheBuster = Date.now();
      baseLayer.getSource().refresh();
      crackLayer.getSource().refresh();
      potholeLayer.getSource().refresh();
    };
    view.on("change:resolution", handleZoomChange);
    
    // ✅ cleanup
    return () => {
      view.un("change:resolution", handleZoomChange);
      if (map && currentLayerRef.current?.length) {
        currentLayerRef.current.forEach((layer) => map.removeLayer(layer));
      }
    };
  }, [mapConfig?.extents, mapConfig?.minZoom, mapConfig?.maxZoom,  projectId, fileId]);

  // 2️⃣ detectionData 변경 시 벡터 레이어 추가
  useEffect(() => {
    if (!olMapRef.current || !detectionData?.detection_details) return;
  
    const map = olMapRef.current;
    const vectorSource = new VectorSource();
  
    // ✅ 1차원이든 2차원이든 모두 평탄화(flat)
    const allDetails = Array.isArray(detectionData.detection_details[0])
      ? detectionData.detection_details.flat()
      : detectionData.detection_details;
  
    console.log("🧭 detection_details 구조:", detectionData);
    console.log("📦 평탄화 후 데이터 개수:", allDetails.length);
  
    // ✅ 모델 타입 감지 (예: Line, Facility 등)
    const modelType = detectionData.model_type || "Unknown";
    console.log("🧠 현재 모델 타입:", modelType);
  
    allDetails.forEach((det) => {
      let feature;
    
      // ✅ 1️⃣ Line 계열 (segmentation polygon)
      // ✅ 1️⃣ Line 계열 (segmentation polygon)
        if (
          det.bbox &&
          det.bbox.type === "rotated_rectangle" &&
          Array.isArray(det.bbox.coordinates)
        ) {
          const coords = det.bbox.coordinates.map(([lon, lat]) =>
            fromLonLat([lon, lat])
          );

          // Polygon 닫기
          if (
            coords.length > 2 &&
            (coords[0][0] !== coords[coords.length - 1][0] ||
              coords[0][1] !== coords[coords.length - 1][1])
          ) {
            coords.push(coords[0]);
          }

          const polygon = new Polygon([coords]);

          feature = new Feature({
            geometry: polygon,
            tile_name: det.tile_name,
            class_id: det.class_id,
            class_name: det.class_name,
            confidence: det.confidence,
            damage_percent: det.damage_percent,
            area_m2: det.area_m2,
            centroid: det.centroid,
            address: det.address
          });

          // 🔥 damage_percent 기준 색상 결정
          let strokeColor = "#00aa00";
          let fillColor = "rgba(0,170,0,0.3)";

          if (det.damage_percent >= 10 && det.damage_percent <= 20) {
            strokeColor = "#ff9900";
            fillColor = "rgba(255,153,0,0.3)";
          } else if (det.damage_percent > 20) {
            strokeColor = "#ff0000";
            fillColor = "rgba(255,0,0,0.3)";
          }

          feature.setStyle(
            new Style({
              stroke: new Stroke({
                color: strokeColor,
                width: 2
              }),
              fill: new Fill({
                color: fillColor
              })
            })
          );
        }

      // ✅ 2️⃣ Crack 계열 (bbox 사용)
      else if (det.bbox && det.bbox.type === "rectangle" && Array.isArray(det.bbox.coordinates)) {
        const coords = det.bbox.coordinates.map(([lon, lat]) => fromLonLat([lon, lat]));

        // 닫기 (첫 좌표와 마지막 좌표가 다르면)
        if (coords.length > 2 && (coords[0][0] !== coords[coords.length - 1][0] || coords[0][1] !== coords[coords.length - 1][1])) {
          coords.push(coords[0]);
        }

        const polygon = new Polygon([coords]);

        feature = new Feature({
          geometry: polygon,
          tile_name: det.tile_name,
          class_id: det.class_id,
          class_name: det.class_name,
          confidence: det.confidence,
          damage_percent: det.damage_percent,
          area_m2: det.area_m2,
          centroid: det.centroid,
          address: det.address
        });

        feature.setStyle(
          new Style({
            stroke: new Stroke({ color: "#ff9900", width: 1 }), // 색상 Line과 다르게
            fill: new Fill({ color: "rgba(255,153,0,0.1)" }),
          })
        );
      }

      // ✅ 3️⃣ Facility / FOD / Pothole 계열 (기존 방식)
      else if (det.coordinates?.bbox) {
        const { top_left, bottom_right } = det.coordinates.bbox;
    
        if (top_left && bottom_right) {
          const polygon = new Polygon([[
            fromLonLat([top_left.x, top_left.y]),
            fromLonLat([bottom_right.x, top_left.y]),
            fromLonLat([bottom_right.x, bottom_right.y]),
            fromLonLat([top_left.x, bottom_right.y]),
            fromLonLat([top_left.x, top_left.y])
          ]]);
    
          feature = new Feature({
            geometry: polygon,
            tile_name: det.tile_name,
            class_id: det.class_id,
            class_name: det.class_name,
            confidence: det.confidence,
            area_m2: det.area_m2,
            centroid: det.centroid,
            address: det.address
          });
    
          feature.setStyle(
            new Style({
              stroke: new Stroke({ color: "#00aaff", width: 2 }),
              fill: new Fill({ color: "rgba(0,170,255,0.2)" }),
            })
          );
        }
      }
    
      if (feature) {
        vectorSource.addFeature(feature);
      }
    });
    
  
    const vectorLayer = new VectorLayer({
      source: vectorSource,
      zIndex: 9999,
    });
  
    map.addLayer(vectorLayer);
  
    // ✅ 선택 기능 추가
  const selectInteraction = new Select({
    condition: click, // 클릭 시 선택 (hover로 바꾸려면 pointerMove)
    layers: [vectorLayer],
    style: (feature) => {
      // ✅ 선택된 feature는 강조 스타일 적용
      return new Style({
        stroke: new Stroke({
          color: "#00FF00", // 초록색
          width: 5,         // 더 두껍게
        }),
        fill: new Fill({
          color: "rgba(0,255,0,0.1)",
        }),
      });
    },
  });

  map.addInteraction(selectInteraction);

  // ✅ 선택 해제 시 원래 스타일로 복구
  selectInteraction.on("select", (e) => {
    // 이전 선택된 feature들 원복
    e.deselected.forEach((f) => {
      f.setStyle(
        new Style({
          stroke: new Stroke({ color: "#ff0000", width: 3 }),
          fill: new Fill({ color: "rgba(255,0,0,0.3)" }),
        })
      );
    });

    // 새로 선택된 feature 강조
    e.selected.forEach((f) => {
      f.setStyle(
        new Style({
          stroke: new Stroke({ color: "#00FF00", width: 5 }),
          fill: new Fill({ color: "rgba(0,255,0,0.1)" }),
        })
      );
    });
  });

  // ✅ cleanup
  return () => {
    map.removeLayer(vectorLayer);
    map.removeInteraction(selectInteraction);
  };
  }, [detectionData]);
  
  // ✅ opacity 변경 시 레이어 반영
  useEffect(() => {
    if (currentLayerRef.current) {
      currentLayerRef.current.setOpacity(opacity);
    }
  }, [opacity]);

  // 1️⃣ OLMap 초기화
  useEffect(() => {
    if (olMapRef.current) return;

    const vworldSatellite = new TileLayer({
      source: new XYZ({
        url: `http://api.vworld.kr/req/wmts/1.0.0/FD995B70-CAC5-3593-9BE5-5D85F490DD23/Satellite/{z}/{y}/{x}.jpeg`,
        crossOrigin: "anonymous",
      }),
      visible: true,
      zIndex: 1,
    });

    // 🔹 OpenStreetMap 기본 지도 레이어
    const osmLayer = new TileLayer({
      source: new OSM(),
      visible: true, // 기본은 OFF (원하면 true 로 변경)
      zIndex: 0,
    });

    // 회사별 좌표 매핑 테이블
    const companyCoordinates = {
      DROMII: fromLonLat([127.1087, 37.3391]), // 한국
      CANADA: fromLonLat([-71.77613225367092, 46.22144604698783]), // 캐나다 퀘벡
      USA: fromLonLat([-100.445882, 39.783730]), // 예: 미국 중심
      MALAYSIA: fromLonLat([101.42322796307243, 2.8464992051196454]), // 말레시아
      // 필요하면 계속 추가
    };

    // 회사 값에 해당하는 좌표가 있으면 가져오고, 없으면 기본 좌표 사용
    const mapCenter =
      companyCoordinates[userCompany] ?? fromLonLat([127.1087, 37.3391]); // 기본값: 한국

    const map = new OLMap({
      target: mapRef.current,
      layers: [osmLayer,vworldSatellite],
      view: new View({
        center: mapCenter,
        zoom: 16,
      }),
    });

    olMapRef.current = map;

    // 클릭 이벤트 등록 (팝업)
    map.on("singleclick", (event) => {
      let clickedFeature = null;
      map.forEachFeatureAtPixel(event.pixel, (feature) => {
        clickedFeature = feature;
      });

      if (clickedFeature) {
        const props = clickedFeature.getProperties();
        setSelectedFeature(props);
        setPopupPixel(event.pixel);
      } else {
        setSelectedFeature(null);
        setPopupPixel(null);
      }
    });
  }, [userRole]); // userRole 의존성 추가

  // ✅ AI 탐지 결과(BBOX) 클릭시 팝업 컴포넌트
  const FeaturePopup = ({ feature, pixel, onClose }) => {
    if (!feature || !pixel) return null;

    const imageSrc = imageMap[feature.class_name] || null;

    return (
      <div
        style={{
          position: "absolute",
          left: pixel[0],
          top: pixel[1],
          background: "#2B2E3A",
          padding: "12px 14px",
          borderRadius: "10px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
          zIndex: 1000,
          transform: "translate(-50%, -110%)",
          color: "white",
        
          fontFamily: "Pretendard, sans-serif",
        }}
      >
        {/* 닫기 버튼 */}
        <div
          onClick={onClose}
          style={{
            position: "absolute",
            top: "6px",
            right: "8px",
            cursor: "pointer",
            color: "#999",
            fontWeight: "bold",
            fontSize: "16px",
            transition: "color 0.2s ease",
          }}
          onMouseEnter={(e) => (e.target.style.color = "#fff")}
          onMouseLeave={(e) => (e.target.style.color = "#999")}
        >
          ×
        </div>

        {/* 이미지 */}
        {imageSrc && (
          <div style={{ textAlign: "center", marginTop: "8px" }}>
            <img
              src={imageSrc}
              alt={feature.class_name}
              style={{
                width: "70px",
                height: "70px",
                borderRadius: "6px",
                objectFit: "cover",
                marginBottom: "8px",
              }}
            />
          </div>
        )}

        {/* 클래스명 */}
        <div
          style={{
            fontWeight: "600",
            fontSize: "15px",
            textAlign: "center",
            marginBottom: "6px",
            color: "#FFFFFF",
          }}
        >
          {nameMap[feature.class_name] || feature.class_name}
        </div>

        {/* 탐지 정확도 */}
        {feature.confidence !== undefined && (
          <InfoBox label={t("info.accuracy")} value={feature.confidence.toFixed(3)} />
        )}

        {/* 손실률 */}
        {feature.damage_percent !== undefined && (
          <InfoBox label={t("info.lossrate")} value={feature.damage_percent} />
        )}

        {/* 면적 */}
        {feature.area_m2 !== undefined && (
          <InfoBox
            label={t("info.area")}
            value={`${Number(feature.area_m2).toFixed(3)} ㎡`}
          />
        )}

        {/* ✅ 주소 */}
        {feature.address !== undefined && (
          <InfoBox label={t("info.address")} value={feature.address} />
        )}
        

        {/* 좌표 */}
        {feature.centroid && (
          <InfoBox
            label={t("info.coordinate")}
            value={`X: ${feature.centroid.lon.toFixed(3)}, Y: ${feature.centroid.lat.toFixed(3)}`}
          />
        )}

      
      </div>
    );
  };

  // ✅ 탐지 정확도 결과 팝업 박스
  const ResultBox = ({ label, value, isRatio = false }) => {
    let color = "#59D89E"; // 기본 녹색

    if (isRatio) {
      const num = parseFloat(value);
      if (!isNaN(num)) {
        if (num <= 5) color = "#59D89E";     // 양호 = 초록
        else if (num <= 15) color = "#DFD744"; // 보통 = 노랑
        else if (num <= 30) color = "#FF9900"; // 주의 = 주황
        else color = "#FF4E4E";                // 위험 = 빨강
      }
    }

    return (
      <div
        style={{
          textAlign: "center",
          fontSize: "13px",
          color: "#BBBBBB",
          backgroundColor: "#1E2027",
          borderRadius: "6px",
          padding: "6px 8px",
          marginTop: "6px",
          wordBreak: "keep-all",
        }}
      >
        {label}:{" "}
        <span style={{ color, fontWeight: "600" }}>{value}</span>
      </div>
    );
  };

  // ✅ 차선 손실률 범례
  const RiskLegend = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-around",
        marginTop: "10px",
        padding: "4px 6px",
        backgroundColor: "#1E2027",
        borderRadius: "6px",
        fontSize: "12px",
        fontWeight: 600,
        color: "#ddd",
      }}
    >
      <span style={{ color: "#59D89E" }}>{t("result.good")}</span>
      <span style={{ color: "#DFD744" }}>{t("result.common")}</span>
      <span style={{ color: "#FF9900" }}>{t("result.caution")}</span>
      <span style={{ color: "#FF4E4E" }}>{t("result.danger")}</span>
    </div>
  );

  return (
    <div className="mapcomponent" style={{ position: 'relative' }}>
      {/* 지도 컨테이너 */}
      <div ref={mapRef} className="map-container" />
      <FeaturePopup
        feature={selectedFeature}
        pixel={popupPixel}
        onClose={() => setSelectedFeature(null)}
      />
      {/* 측정 토글 버튼 (원하는 위치에 배치) */}
      <button
  style={{
    position: "absolute",
    right: 20,
    bottom: 40,
    zIndex: 2000,
    width: 44,
    height: 44,
    cursor: "pointer",
    backgroundColor: isMeasuring ? "#9D91FF" : "#555",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "0.25s",
    boxShadow: "0 3px 8px rgba(0,0,0,0.35)",
    borderRadius: "3px",         // px 단위 명시
    border: "1px solid white",   // 정상 적용
  }}
  
  onClick={() => {
    setIsMeasuring((s) => !s);

    if (!isMeasuring) {
      setMeasureResult(null);
    } else {
      const map = olMapRef.current;
      if (map) {
        map.getOverlays().getArray().forEach((o) => {
          const el = o.getElement();
          if (el && el.innerHTML?.includes(`${t("line.totalLine")}`)) map.removeOverlay(o);
          if (el && el.innerHTML?.match(/m|km/)) map.removeOverlay(o);
        });
      }
    }
  }}
>
  <img
    src={Subtractionicon}
    alt="측정 아이콘"
    style={{
      width: "42px",
      height: "42px",
      // filter: "invert(1)", // 아이콘을 밝게 표시 (배경 어두울 때 유용)
      // opacity: isMeasuring ? 1 : 0.8
    }}
  />
</button>

<div style={{
    position: "absolute",
    right: 20,
    top: 10,
    zIndex: 2000,
    width: 500,
    display:'flex',
    justifyContent:'end',
  }}>
<DetectionDashboard detectionData={detectionData}/> 

</div>


{/* 결과 박스 */}
{measureResult && (
  <div
    style={{
      position: "absolute",
      right: 20,
      bottom: 100,
      zIndex: 2000,
      background: "#2B2E3A",
      padding: "16px 18px",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.35)",
      minWidth: 230,
      color: "#ffffff",
      fontFamily: "Pretendard, sans-serif",
    }}
  >
    {/* 제목 */}
    <div
      style={{
        fontWeight: 700,
        fontSize: "16px",
        textAlign: "center",
        marginBottom: "10px",
        color: "#FFFFFF",
      }}
    >
      {t("result.title")}
    </div>

    {/* 결과값들 */}
    <ResultBox label={t("result.area")} value={`${(measureResult.drawnArea || 0).toFixed(2)} ㎡`} />
    <ResultBox label={t("result.count")} value={measureResult.matchedCount} />
    <ResultBox label={t("result.dataarea")} value={`${measureResult.featuresAreaSum.toFixed(2)} ㎡`} />
    <ResultBox
      label={t("result.ratio")}
      value={`${measureResult.ratio !== null ? (measureResult.ratio * 100).toFixed(2) : "N/A"} %`}
      isRatio // 🔹 색상 자동 계산 플래그
    />

    {/* 🔻 범례 추가 */}
    <RiskLegend />

    

    {/* 닫기 버튼 */}
    <button
      onClick={() => setMeasureResult(null)}
      style={{
        marginTop: "12px",
        width: "100%",
        background: "#1E2027",
        padding: "8px 0",
        color: "#fff",
        borderRadius: "6px",
        border: "1px solid #444",
        cursor: "pointer",
        fontWeight: 600,
        fontSize: "14px",
        transition: "0.2s",
      }}
      onMouseEnter={(e) => (e.target.style.background = "#3A3E4A")}
      onMouseLeave={(e) => (e.target.style.background = "#1E2027")}
    >
      {t("result.close")}
    </button>
  </div>
)} 
{/* 라인 범례 */}
{modelType === "Line" && <DamageLegend />}

    




     
    </div>
  );
};

export default Map;
